import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './javascript/cast/cast-service';
import reportWebVitals from './reportWebVitals';



// >>>>>>>>>>>>>>> Added to try and fix the issue with the app crashing on startup. (BLue Screen Issue) --- START
const STARTUP_SELF_HEAL_ATTEMPTS_KEY = 'sme.startupSelfHeal.attempts';
const STARTUP_SELF_HEAL_WINDOW_MS = 15000;
const STARTUP_SELF_HEAL_MAX_ATTEMPTS = 1;

const startupTime = Date.now();
let didTriggerSelfHeal = false;
const startupSelfHealPatterns = [
  'Invalid hook call',
  "Cannot read properties of null (reading 'useState')",
  "Cannot read properties of undefined (reading 'send')",
];

const parseSelfHealAttempts = () => {
  const value = Number(sessionStorage.getItem(STARTUP_SELF_HEAL_ATTEMPTS_KEY) || '0');
  return Number.isFinite(value) ? value : 0;
};

const isStartupRuntimeError = (message = '') => {
  return startupSelfHealPatterns.some((pattern) => message.includes(pattern));
};

const tryStartupSelfHeal = (source, message) => {
  if (Date.now() - startupTime > STARTUP_SELF_HEAL_WINDOW_MS) {
    return;
  }

  const attempts = parseSelfHealAttempts();
  if (attempts >= STARTUP_SELF_HEAL_MAX_ATTEMPTS) {
    return;
  }

  didTriggerSelfHeal = true;
  sessionStorage.setItem(STARTUP_SELF_HEAL_ATTEMPTS_KEY, String(attempts + 1));
  console.error(`Startup self-heal reload triggered by ${source}:`, message);
  window.location.reload();
};

const onWindowError = (event) => {
  const message = event?.error?.message || event?.message || '';
  if (isStartupRuntimeError(String(message))) {
    tryStartupSelfHeal('error', message);
  }
};

const onUnhandledRejection = (event) => {
  const reason = event?.reason;
  const message = typeof reason === 'string'
    ? reason
    : (reason?.message || '');

  if (isStartupRuntimeError(String(message))) {
    tryStartupSelfHeal('unhandledrejection', message);
  }
};

window.addEventListener('error', onWindowError, true);
window.addEventListener('unhandledrejection', onUnhandledRejection, true);

setTimeout(() => {
  if (!didTriggerSelfHeal) {
    sessionStorage.setItem(STARTUP_SELF_HEAL_ATTEMPTS_KEY, '0');
  }
  window.removeEventListener('error', onWindowError, true);
  window.removeEventListener('unhandledrejection', onUnhandledRejection, true);
}, STARTUP_SELF_HEAL_WINDOW_MS);

// >>>>>>>>>>>>>>> Added to try and fix the issue with the app crashing on startup. (BLue Screen Issue) --- END

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);


// Null Update

// Service worker update handling is now in PWAUpdateHandler component



// Service worker registration is now handled automatically by Vite PWA plugin
// The update notifications and offline functionality are preserved in the PWA config

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
// reportWebVitals(console.log);
